import React from 'react'
import classNames from 'classnames'
import scrollIntoView from 'scroll-into-view'

import SpecificTemplateIcon from 'components/Templates/Icon'

export default function Item({ id, children, selected, onClick, index }) {
  const elementRef = React.useRef()

  React.useEffect(
    () => {
      if (selected) {
        scrollIntoView(elementRef.current, { behavior: 'smooth' })
      }
    },
    [selected]
  )

  return (
    <div
      ref={elementRef}
      id={id}
      style={{ height: 48, minWidth: 0 }}
      className={classNames(
        'flexbox flexbox-align-center transition background-shade-50-on-hover shade-05 font-size-large pointer radius-normal',
        { 'background-shade-50': selected }
      )}
      onClick={() => onClick({ id, index })}
    >
      <div
        className="shadow-right--small flexbox-no-shrink flexbox-align-center flexbox flexbox-justify-center background-white shade-30 radius-normal margin-horizontal-small"
        style={{ height: 32, width: 32 }}
      >
        <SpecificTemplateIcon templateId={id} />
      </div>
      <div className="margin-left-smaller ellipsis font-weight-medium">
        {children}
      </div>
    </div>
  )
}
